import React, { useContext, useState, useEffect } from 'react';
import NavBar from '../../components/NavBar';
import HighSchoolMentorTable from '../../components/HighSchoolMentorTable';
import LoginForm from '../../components/LoginForm';
import { fetchHighSchoolMentors } from '../../services/HighSchoolMentorService'; // Import the service function
import { AuthContext } from '../../contexts/AuthContext'; // Import AuthContext

function SchedulerPage() {
    const { isAuthenticated } = useContext(AuthContext);
    const [mentors, setMentors] = useState([]); // State to hold mentor data
    const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
    const [resultsPerPage] = useState(10); // Number of results per page
    const [totalResults, setTotalResults] = useState(0); // Total number of results
    const [searchTerm, setSearchTerm] = useState(''); // Search term for filtering
    const [sortOption, setSortOption] = useState(''); // Sort option for sorting
    const [loading, setLoading] = useState(true); // Loading state

    // Fetch mentors from the backend
    useEffect(() => {
        if (isAuthenticated) {
            const fetchMentors = async () => {
                try {
                    const data = await fetchHighSchoolMentors(); // Call the service function
                    setMentors(data); // Set the fetched data to state
                    setTotalResults(data.length); // Set the total number of results
                } catch (error) {
                    console.error('Error fetching mentors:', error); // Log any errors
                } finally {
                    setLoading(false); // Mark loading as complete
                }
            };

            fetchMentors(); // Fetch mentors when the component mounts
        } else {
            setLoading(false); // Stop loading if not authenticated
        }
    }, [isAuthenticated]);

    // Filter and sort mentors based on searchTerm and sortOption
    const filteredMentors = mentors
        .filter(mentor =>
            mentor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            mentor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            mentor.grade.toLowerCase().includes(searchTerm.toLowerCase()) ||
            mentor.di_experience.toString().toLowerCase().includes(searchTerm.toLowerCase()) || // Convert boolean to string
            mentor.interest_area.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            if (!sortOption) return 0;
            if (a[sortOption] < b[sortOption]) return -1;
            if (a[sortOption] > b[sortOption]) return 1;
            return 0;
        });

    // Paginate the filtered mentors
    const paginatedMentors = filteredMentors.slice(
        (currentPage - 1) * resultsPerPage,
        currentPage * resultsPerPage
    );
    console.log('Mentors State:', mentors); // Log the mentors state
    console.log('Filtered Mentors:', filteredMentors); // Log the filtered mentors
    console.log('Paginated Mentors:', paginatedMentors); // Log the paginated mentors
  
    if (loading) {
        return <div>Loading...</div>; // Show a loading indicator while fetching data
    }

    if (!isAuthenticated) {
        return (
            <div>
                <LoginForm />
            </div>
        ); // Show a message if not authenticated
    }

    return (
        <div>
            <HighSchoolMentorTable
                mentors={paginatedMentors} // Pass paginated mentors
                currentPage={currentPage} // Pass current page
                resultsPerPage={resultsPerPage} // Pass results per page
                onPageChange={setCurrentPage} // Pass page change handler
                totalResults={filteredMentors.length} // Pass total filtered results
                setSortOption={setSortOption} // Pass sort option handler
                setSearchTerm={setSearchTerm} // Pass search term handler
            />
        </div>
    );
}

export default SchedulerPage;